import { combineReducers } from "redux";

import themeSlice from "../features/theme/themeSlice";
import authSlice from "../features/Auth/authSlice";
import modalSlice from "../features/modals/modalSlice";
import devSlice from "../features/Dev/devSlice";
import skillSlice from "../features/Dev/skillSlice";
import snackBarSlice from "../features/modals/snackBarSlice";
import projectSlice from "../features/Dev/projectSlice";
import socialSlice from "../features/Dev/socialSlice";
import homeSlice from "../features/Dev/homeSlice";
import developerSlice from "../features/Developers/developerSlice";

const rootReducer = combineReducers({
  theme: themeSlice,
  auth: authSlice,
  modal: modalSlice,
  dev: devSlice,
  skill: skillSlice,
  snackBar: snackBarSlice,
  project: projectSlice,
  social: socialSlice,
  home: homeSlice,
  developers: developerSlice,
});

export default rootReducer;
